import React from 'react';
import Text from './Text';
import Token from './Token';
import { RollValue, ResourceName, RESOURCE_TYPES } from '../game-info';

interface HexProps {
  sideLength: number;
  x: number;
  y: number;
  label: string;
  type: ResourceName;
  rollValue: RollValue;
}

export default function Hex({
  sideLength,
  x,
  y,
  label,
  type,
  rollValue,
}: HexProps) {
  const short = sideLength / 2;
  const med = short * SQRT_3;
  const pathCmds = [
    `m ${-short} ${-med}`,
    `h ${sideLength}`,
    `l ${short} ${med}`,
    `l ${-short} ${med}`,
    `h ${-sideLength}`,
    `l ${-short} ${-med}`,
    `z`,
  ];
  const pathData = pathCmds.join(' ');
  return (
    <g transform={`translate(${x}, ${y})`}>
      <path
        fill="rgb(240, 221, 183)"
        transform={`scale(1.08, 1.08)`}
        d={pathData}
      />
      <path
        stroke="rgba(0,0,0,0.15)"
        strokeWidth={sideLength / 60}
        transform={`scale(0.91, 0.91)`}
        fill={RESOURCE_TYPES[type].bg}
        d={pathData}
      />
      <Text
        x={-short + short / 6}
        y={-med + med / 4}
        align="left"
        size={sideLength / 7}
        weight="400"
        color={RESOURCE_TYPES[type].fg}
        text={label}
        opacity={0.5}
      />
      <Token
        value={rollValue}
        size={sideLength / 2}
      />
    </g>
  );
}

const SQRT_3 = Math.sqrt(3);
